import { render, staticRenderFns } from "./SolucionesPage.vue?vue&type=template&id=9a1117d8&scoped=true"
import script from "./SolucionesPage.vue?vue&type=script&lang=js"
export * from "./SolucionesPage.vue?vue&type=script&lang=js"
import style0 from "./SolucionesPage.vue?vue&type=style&index=0&id=9a1117d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1117d8",
  null
  
)

export default component.exports